/**
 * @description: 自动注册全局指令
 */

import { handleImportAllFileData, inVite } from '@/utils/api';
let files;
if (inVite()) {
  files = import.meta.glob('./**/*.js', { eager: true });
} else {
  files = require.context('./', true, /\.js$/);
}
const filesInfo = handleImportAllFileData(files, !inVite(), ['./index.js']);

export default {
  install(app) {
    // 注册所有指令
    for (const key in filesInfo) {
      app.directive(key, filesInfo[key]);
    }
  }
};
